import { useState } from 'react';
import { 
    Box, Button, Card, CardContent, Grid, Typography, Dialog, DialogTitle, DialogContent, DialogActions
} from '@mui/material';
import { useLocation, useNavigate } from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ErrorIcon from '@mui/icons-material/Error';
import Helpers from '../Helpers';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

const styles = {
    header: {
        display: 'flex', 
        flexDirection: 'row', 
        alignItems: 'center',
        gap: 2,
        paddingBottom: '3%',
        marginBottom: '2%',
        borderBottom: '2px solid red',
    },
    box: {
        width: '100%',
        backgroundColor: '#FFF',
        padding: '1%',
    },
    gridItem: {
        display: 'flex', 
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    codPedido:{
        fontWeight: 'bold',
    },
    data: {
        fontWeight: 'bold',
    },
    descPedido: {
        fontSize: 12,
        fontStyle: 'italic',
        marginTop: .5
    },
    title: {
        fontSize: 12,
        fontWeight: 'bold',
        textTransform: 'uppercase'
    },
    cod_produto: {
        width: '12%',
        fontSize: 12,
        fontStyle: 'italic',
        padding: '2px 6px',
        borderRadius: 4,
        color: '#F5F5F5',
        backgroundColor: 'rgba(0,0,0, .6)',
    },
};

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function DetalhesPedido(){
    const navigate = useNavigate();
    const location = useLocation();
    const pedido = location.state?.pedido;
    const filtro = location.state?.filtroPedidos;
    const [imgProduto, setImgProduto] = useState(null);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [itemImpostos, setItemImpostos] = useState([]);

    const handleOpenModal = (item) => {
        const impostos = [
            { chave: 'vr_unitorigem', valor: `R$ ${Helpers.formataValorPtBr(item.vr_unitorigem)}` },
            { chave: 'vr_unitario', valor: `R$ ${Helpers.formataValorPtBr(item.vr_unitario)}` },
            { chave: 'vr_unitariodesc', valor: `R$ ${Helpers.formataValorPtBr(item.vr_unitariodesc)}` },
            { chave: 'vr_redubaseicmsst', valor: `${item.vr_redubaseicmsst}%` },
            { chave: 'vr_aliquotaicmsst', valor: `${item.vr_aliquotaicmsst}%` },
            { chave: 'vr_icmsst', valor: `R$ ${Helpers.formataValorPtBr(item.vr_icmsst)}` },
            { chave: 'vr_baseicmsst', valor: `R$ ${Helpers.formataValorPtBr(item.vr_baseicmsst)}` },
            { chave: 'desconto', valor: `R$ ${Helpers.formataValorPtBr(item.desconto)}` },
            { chave: 'desconto_porcentagem', valor: `${item.desconto_porcentagem}%`},
            { chave: 'vr_alqinterna', valor: `${item.vr_alqinterna}%` },
            { chave: 'vr_alqinterestadual', valor: `${item.vr_alqinterestadual}%` },
            { chave: 'vr_mva', valor: `${item.vr_mva}%` },
            { chave: 'vr_aliquotaicms', valor: `${item.vr_aliquotaicms}%` },
            { chave: 'ds_modalbcicmsst', valor: item.ds_modalbcicmsst },
            { chave: 'vbcfcpst', valor: `R$ ${Helpers.formataValorPtBr(item.vbcfcpst)}` },
            { chave: 'pfcpst', valor: `R$ ${Helpers.formataValorPtBr(item.pfcpst)}` },
            { chave: 'vfcpst', valor: `R$ ${Helpers.formataValorPtBr(item.vfcpst)}` },
            { chave: 'cd_cest', valor: item.cd_cest },
            { chave: 'cd_enquadraipi', valor: item.cd_enquadraipi },
            { chave: 'cd_csosn', valor: item.cd_csosn },
            { chave: 'cd_cfop', valor: item.cd_cfop }
        ];

        setItemSelecionado(item);
        setItemImpostos(impostos);
    };

    const handleCloseModal = () => setItemSelecionado(null);

    // const renderImage = (item)=>{
    //     let newImg = item;

    //     if(newImg !== null && newImg.includes('images/produtos')){
    //         setImgProduto({ uri: newImg });
    //     }else{
    //         setImgProduto(require('../images/noimage.png'));
    //     }
    // };

    const ItemProduto = ({item, onOpen}) => {
        // renderImage(item.cm_imagem);

        console.log('item', item);

        return (
            <Card sx={{ marginBottom: 1 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    {/* <CardMedia
                        component="img"
                        sx={{ width: 120 }}
                        image={imgProduto}
                    /> */}
                    {/* <CardContent sx={{ flex: '1 0 auto' }}> */}
                    <CardContent sx={{ flex: '1', padding: 1, }}>
                        <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, width: '90%', alignItems: 'center' }}>
                                <Typography component="div" style={styles.cod_produto}> {`Cod: ${item.cd_produto}`} </Typography>
                                <Typography component="div" sx={{ fontWeight: 'bold' }}> {item.ds_produto} </Typography>
                            </Box>

                            <Button onClick={onOpen} startIcon={<ErrorIcon />} />
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'space-between' }} >
                            <Typography variant="subtitle1" component="div" sx={{ color: 'text.secondary' }}>
                                {`${item.quantidade} ${item.ds_unidade} x ${Helpers.formataValorPtBr((item.vr_unitariodesc + (item.vr_icmsst/item.quantidade)))}`}
                            </Typography>
                            <Typography variant="subtitle1" component="div" sx={{ fontWeight: 'bold' }}>
                                {`R$ ${Helpers.formataValorPtBr((item.quantidade * (item.vr_unitariodesc + (item.vr_icmsst/item.quantidade))))}`}
                            </Typography>
                        </Box>
                    </CardContent>
                </Box>

                {
                    (item.ds_obs !== null) &&
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Typography component="div" sx={{ fontWeight: 'bold' }}> Observações </Typography>
                        <Typography component="div"> {item.ds_obs} </Typography>
                    </Box>
                }
            </Card>
        );
    };

    return (
        <Grid container spacing={2} rowSpacing={2}>
            <Grid size={12} sx={styles.header} >
                <Button 
                    variant="contained" 
                    size="small" 
                    startIcon={<ArrowBackIcon />} 
                    onClick={()=> navigate('/pedidos', { state: { params: filtro }})}
                    sx={{ backgroundColor: '#f5f5f5', color: 'rgba(0,0,0, .8)' }}
                > 
                    sair
                </Button>

                <Typography
                    sx={{
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        fontSize: 14,
                    }}
                >
                    { pedido.nm_cliente }
                </Typography>
            </Grid>

            <Grid size={{ md: 6, xs: 12 }} offset={{ md: 3 }} sx={styles.box}>
                <Grid item sx={styles.gridItem}>
                    <Typography sx={styles.codPedido}>{`Cód pedido: ${pedido.cd_venda} | Id pedido: ${pedido.id}`}</Typography>
                    <Typography sx={styles.data}>{pedido.dt_venda} {pedido.hr_venda}</Typography>
                </Grid>
                <Grid item sx={styles.gridItem}>
                    <Typography>{`Tabela de preço: ${pedido.ds_tabpreco}`}</Typography>
                </Grid>
                <Grid item sx={styles.gridItem}>
                    <Typography>{`Pagamento: ${pedido.ds_tipopagto} - ${pedido.ds_cartaocred}`}</Typography>
                    <Typography>{pedido.ds_formapagto}</Typography>
                </Grid>
                 <Grid item sx={styles.gridItem}>
                    <Typography sx={styles.codPedido}>{`Valor pedido: R$ ${Helpers.formataValorPtBr(pedido.vr_total)}`}</Typography>
                </Grid>
                <Grid item sx={styles.gridItem}>
                    <Typography sx={styles.descPedido}>{`Desconto: ${pedido.porcDesc}% (R$ ${Helpers.formataValorPtBr(pedido.totalDescontoReal)})`}</Typography>
                </Grid>
                <Grid item sx={styles.gridItem}>
                    <Typography>{`Vendedor: ${pedido.nm_vendedor}`}</Typography>
                </Grid>
            </Grid>

            <Grid size={{ md: 6, xs: 12 }} offset={{ md: 3 }} sx={styles.box}>
                {
                    (pedido.itens.length > 0) &&
                    pedido.itens.map((item, index)=>{
                        return <ItemProduto key={index} item={item} onOpen={() => handleOpenModal(item)}/>;
                    })
                }
            </Grid>

            <>
                <Dialog
                    open={!!itemSelecionado}
                    onClose={handleCloseModal}
                    scroll={'paper'}
                    aria-labelledby="scroll-dialog-title"
                    aria-describedby="scroll-dialog-description"
                >
                    <DialogTitle id="scroll-dialog-title">
                        <Typography style={styles.title}>{`Impostos produto:`}</Typography>
                        <Typography style={styles.title}>{`cod: ${itemSelecionado?.cd_produto} ${itemSelecionado?.ds_produto}`}</Typography>
                    </DialogTitle>

                    <DialogContent dividers={'paper'}>
                        <TableContainer>
                            <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
                                <TableBody>
                                    {
                                        itemImpostos.map((item, index)=>{
                                            return (
                                                <TableRow key={index} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell>{item.chave}</TableCell>
                                                    <TableCell>{item.valor}</TableCell>
                                                </TableRow>
                                            );
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </DialogContent>
                </Dialog>
            </>

        </Grid>
    );
}

export default DetalhesPedido;